resourcePaths = '{"rootPath":"","assetsPath":""}';function _Secured() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  // Session
  this._session = new Session();

  // CONSTANTS
  this._SECURED_DOMAIN = "/member";
  this._LOGOUT_PATH = "/login?notification=logged-out";
  this._SESSION_EXPIRE_PATH = "/login?notification=expired-session";
  this._LOGIN_PATH = "/login";
  this._DEFAULT_LOGGEDIN_PATH = "/member/dashboard/home";


  this.init = function () {
    // Check for cookie
    if (!this.isLoggedIn()) {
      // Redirect to login
      window.location.replace(this._LOGIN_PATH + window.location.search);
    }

    // Logout Link
    $("#logout").on("click", $.proxy(this._onLogout, this));

    // Expire session
    this._session.setSessionExpirationCallback($.proxy(this._onSessionExpire, this));

    // Timeout warning
    this._session.setSessionTimeoutWarningCallback($.proxy(this._onSessionTimeoutWarning, this));
  };


  this.initAllReady = function () {};

  this.isLoggedIn = function() {
    return !(this._session.getAuthToken() == "");
  };

  this._onLogout = function (evt) {
    this._session.deleteSession($.proxy(this._onLogoutSuccess, this));
    if (evt)
      evt.preventDefault();
  };

  this._onLogoutSuccess = function () {
    var redirect_path = this._LOGOUT_PATH;
    window.location.replace(redirect_path);
  };

  this._onSessionExpire = function() {
    if (location.href.indexOf(location.host + this._SECURED_DOMAIN) != -1) {
      var redirect_path = this._SESSION_EXPIRE_PATH;
      window.location.replace(redirect_path);
    }
  };



  this._onSessionTimeoutWarning = function() {
    if(!$("#session-timeout-dialog").mogo().declaredClass) {
      var dialog = $("#session-timeout-dialog")
        .mogo()
        .create("Dialog", {
          backgroundClose: false,
          close: false
        });
      // Countdown content
      $("#SessionTimeoutWarning")
        .mogo()
        .create("SessionTimeoutWarning", {}, "page");
      $("#session-timeout-dialog").mogo().show();
    } else {
      $("#session-timeout-dialog").mogo().show();
      $("#SessionTimeoutWarning").mogo().startCountdown();
    }
  };
}
